import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { BsChatRight, BsFillTriangleFill } from "react-icons/bs";

const TableHeader = ({
  columns,
  order,
  sort,
  handleSortChange,
  metaSortable,
  stickyActions,
  onDragStart,
  onDragOver,
  onDragEnd,
  onDrop,
}) => {
  const [orderBy, setOrderBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  useEffect(() => {
    if (order && sort) {
      setOrderBy(order);
      setSortOrder(sort);
    }
  }, [order, sort]);

  const handleOrderBy = (dbName, order) => {
    setOrderBy(dbName);
    setSortOrder(order);
    handleSortChange(dbName, order);
  };

  const orderby = (column) => {
    const { dbName, label } = column;
    const isMeta = typeof dbName === "string" && dbName.startsWith("meta.");
    // Meta-Sortierung ist serverseitig nur für die Haupt-Tabelle implementiert;
    // an anderen Endpoints (Report/Archiv) gibt es deshalb keine Sortier-Pfeile.
    if ((isMeta && !metaSortable) || column.sortable === false) {
      return <span>{label}</span>;
    }
    const arrowStyle = {
      position: "absolute",
      right: "1rem",
      fontSize: ".5em",
    };
    return (
      <div style={{ position: "relative" }}>
        <span>{label}</span>
        <BsFillTriangleFill
          style={{
            ...arrowStyle,
            top: "calc(50% - 8px)",
            cursor: "pointer",
            opacity: orderBy === dbName && sortOrder === "ASC" ? 1 : 0.5,
          }}
          onClick={() => handleOrderBy(dbName, "ASC")}
        />

        <BsFillTriangleFill
          style={{
            ...arrowStyle,
            transform: "rotate(180deg)",
            bottom: "calc(50% - 8px)",
            cursor: "pointer",
            opacity: orderBy === dbName && sortOrder === "DESC" ? 1 : 0.5,
          }}
          onClick={() => handleOrderBy(dbName, "DESC")}
        />
      </div>
    );
  };

  return (
    <thead>
      <tr>
        {columns.map((column) => {
          const isMeta =
            typeof column.dbName === "string" &&
            column.dbName.startsWith("meta.");
          return (
            <th
              key={column.dbName}
              draggable={isMeta && typeof onDragStart === "function"}
              onDragStart={(e) => isMeta && onDragStart(e, column.key)}
              onDragOver={isMeta ? onDragOver : undefined}
              onDragEnd={onDragEnd}
              onDrop={(e) => isMeta && onDrop(e, column.key)}
            >
              {orderby(column)}
            </th>
          );
        })}
        <th
          className={stickyActions ? "sticky-actions" : undefined}
          style={{ textAlign: "right" }}
        ></th>
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dbName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      format: PropTypes.string,
    }),
  ).isRequired,
  order: PropTypes.string,
  sort: PropTypes.oneOf(["ASC", "DESC"]),
  handleSortChange: PropTypes.func.isRequired,
  metaSortable: PropTypes.bool,
  stickyActions: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragEnd: PropTypes.func,
  onDrop: PropTypes.func,
};

export default TableHeader;
